<template>
    <div class="mb-8 flex">
        <div class="w-16 text-gray-800 font-sm font-semibold leading-10 flex-shrink-0">
            <label>Dots</label>
        </div>

        <div class="w-full">
            <Listbox v-model="type">
                <div class="relative mt-1">
                    <ListboxButton
                        class="relative w-full cursor-default rounded-lg bg-gray-200 h-10 pl-3 pr-10 text-left focus:outline-none ">
                        <span class="block truncate capitalize">{{ type.name }}</span>
                        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                    </ListboxButton>
                    <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                        <ListboxOptions
                            class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            <ListboxOption v-slot="{ active, selected }" v-for="dot in dots" :key="dot.value" :value="dot"
                                as="template">
                                <li :class="[
                                    active ? 'bg-amber-100 text-success' : 'text-gray-900',
                                    'relative cursor-default select-none py-2 pl-4 pr-10',
                                ]">
                                    <span :class="[
                                        selected ? 'font-medium' : 'font-normal',
                                        'block truncate',
                                    ]">{{ dot.name }}</span>
                                    <span v-if="selected"
                                        class="absolute inset-y-0 right-0 flex items-center pl-3 text-success">
                                        <CheckIcon class="h-5 w-5" aria-hidden="true" />
                                    </span>
                                </li>
                            </ListboxOption>
                        </ListboxOptions>
                    </transition>
                </div>
            </Listbox>
        </div>
    </div>
</template>
<script>
import configMixins from "../config.mixin";
import {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue'
import {
    SelectorIcon, CheckIcon
} from "vue-tabler-icons"
export default defineComponent({
    components: {
        Listbox,
        ListboxLabel,
        ListboxButton,
        ListboxOptions,
        ListboxOption, SelectorIcon, CheckIcon
    },
    mixins: [configMixins],
    data() {
        return {
            dots: [{
                value: "",
                image: "",
                name: "None",
            },
            {
                value: "dots",
                image: "/images/dots/dots.png",
                name: "Dots",
            },
            {
                value: "rounded",
                image: "/images/dots/rounded.png",
                name: "Rounded",
            },
            {
                value: "classy",
                image: "/images/dots/classy.png",
                name: "Classy",
            },
            {
                value: "classy-rounded",
                image: "/images/dots/classy_rounded.png",
                name: "Classy Rounded",
            },
            {
                value: "square",
                image: "/images/dots/square.png",
                name: "Square",
            },
            {
                value: "extra-rounded",
                image: "/images/dots/extra_rounded.png",
                name: "Extra Rounded",
            },
            ],
            type: {
                value: "square",
                image: "/images/dots/square.png",
                name: "Square",
            },
        };
    },
    created() {

    },
    methods: {

    },
    watch: {
        type(v) {
            this.config.dotsOptions.type = v.value
        }
    }
})
</script>
  